(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-psych-intakes', {
            parent: 'app',
            url: '/download-psych-intakes',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                pageTitle: 'global.menu.entities.downloadPsychIntake'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-psych-intakes/download-psych-intakes.html',
                    controller: 'DownloadPsychIntakesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('downloadResult');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
        });
    }

})();
